export const tokenImages = {
    ETH: "/assets/createtask/eth.svg",
    USDT: "/assets/createtask/usdtT.svg",
    USDC: "/assets/createtask/usdc.svg",
    LINK: "/assets/createtask/link.svg",
    PEPE: "/assets/createtask/pepe.svg",
    UNI: "/assets/createtask/uni.svg",
    DOP: "/assets/createtask/dop1.svg",
    WBTC: "/assets/createtask/wbtc.svg",
    Tomi: '/assets/createtask/tomi.svg',
    TASK: "/assets/createtask/Tasktoken.png",
    ORC: "/assets/createtask/Orctoken.png"
};